"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssuranceThemeProvider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var CssBaseline_1 = __importDefault(require("@mui/material/CssBaseline"));
var styles_1 = require("@mui/material/styles");
var createAssuranceTheme_1 = require("./createAssuranceTheme");
/**
 * AssuranceThemeProvider
 *
 * Sets up the Assurance Theme and related stylesheets
 */
function AssuranceThemeProvider(_a) {
    var _b = _a.theme, theme = _b === void 0 ? (0, createAssuranceTheme_1.createAssuranceTheme)() : _b, children = _a.children;
    return ((0, jsx_runtime_1.jsxs)(styles_1.ThemeProvider, __assign({ theme: theme }, { children: [(0, jsx_runtime_1.jsx)(CssBaseline_1.default, {}), (0, jsx_runtime_1.jsx)(styles_1.StyledEngineProvider, __assign({ injectFirst: true }, { children: children }))] })));
}
exports.AssuranceThemeProvider = AssuranceThemeProvider;
